import { render, staticRenderFns } from "./MantenedorServipagPantalla.vue?vue&type=template&id=f5e63fb0&"
import script from "./MantenedorServipagPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorServipagPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f5e63fb0', component.options)
    } else {
      api.reload('f5e63fb0', component.options)
    }
    module.hot.accept("./MantenedorServipagPantalla.vue?vue&type=template&id=f5e63fb0&", function () {
      api.rerender('f5e63fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorServipag/MantenedorServipagPantalla.vue"
export default component.exports